import { FC } from "react"
import { Outlet } from "react-router-dom";
import { CommonHeader } from "../parts/CommonHeader";
import { isHeritageClause } from "typescript";
import { CommonFooter } from "../parts/CommonFooter";

export const ThanksPageLayout: FC = () => {
  return  <>
    <div className="">
      <CommonHeader />
      <div className="w-full">
        <div className="text-center mt-12 mx-4 min-h-[calc(100vh-400px)]">
          <img src="/images/drop-icon.png" alt="drop-icon" className="mx-auto h-[120px]" />
          <Outlet />
          <div className="mt-6 mb-20">
            <a href="/image-generation" className="secondary-button py-2 px-12 rounded font-bold clickable">生成画面に戻る</a>
          </div>
        </div>
      </div>
      <CommonFooter />
    </div>
  </>
}